import { node, shape, string } from 'prop-types';
import React, { useState } from 'react';
import { Modal, ModalTypes } from '@eika/modal';
import { IconButton, StandardButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

const HelpModal = ({ question, appNamespace }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const closeModal = () => setIsModalOpen(false);

    const showModal = (e) => {
        e.preventDefault();
        setIsModalOpen(true);
    };

    const { modalButtonLabel, info, infotittel } = question;

    if (info == null || infotittel == null) {
        return null;
    }

    return (
        <>
            {modalButtonLabel != null ? (
                // TODO: Change to use icon if incoming
                <StandardButton aria-label={modalButtonLabel} className="kdk-skjema-ikon-help left" onClick={showModal}>
                    <span className="kdk-skjema-help-text">{modalButtonLabel}</span>
                </StandardButton>
            ) : (
                <IconButton
                    aria-label="Hjelpetekst"
                    className="right"
                    onClick={showModal}
                    icon={IconTypes.INFO_36}
                    id={`help-icon-${question.definisjon}`}
                />
            )}
            <Modal
                headerText={infotittel}
                onClickCallback={closeModal}
                onClose={closeModal}
                show={isModalOpen}
                id="helpermodal__modal"
                type={ModalTypes.STANDARD}
                appNamespace={appNamespace}
            >
                <div role="tooltip" id="helpermodal">
                    <div className="card">
                        <div className="sub-card-content">
                            <div className="card-header">
                                <h2>{infotittel}</h2>
                            </div>
                            {/* eslint-disable react/no-danger */}
                            {/* Necessary use of dangerouslySetInnerHTML */}
                            <div className="card-body ahv-card-body" dangerouslySetInnerHTML={{ __html: info }} />
                            <StandardButton className="modal-knapp" onClick={closeModal}>
                                <i className="ikon-kryss-36" aria-hidden />
                                <span className="sr-only">Lukk</span>
                            </StandardButton>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
HelpModal.propTypes = {
    question: shape({
        modalButtonLabel: string,
        info: node,
        infotittel: string,
    }).isRequired,
    appNamespace: string,
};
export default HelpModal;
